import { Fragment } from 'react'
import styled from 'styled-components'
import MoreQuestions from '../../../../../../shared/components/more-questions'

const Container = styled.div`
    margin-top: 80px;
`

const MoreQuestionsComponent = styled(MoreQuestions)`
    width: 90%;
`

const description = (
    <Fragment>
        Have a feature request or bug to report? <span>Get in touch with GIPHY Support.</span>
    </Fragment>
)

const SupportCTA = () => (
    <Container>
        <MoreQuestionsComponent
            title={'Got More Questions?'}
            description={description}
            helpLink={`https://support.giphy.com/hc/en-us/articles/360049349132-GIPHY-Super-Cut`}
        />
    </Container>
)

export default SupportCTA
